import { ArrowLeftIcon } from "lucide-react";
import { Link, useParams } from "react-router-dom";

import { PageHeader } from "@/components/page-header";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { useCongress } from "@/features/congress-select/hooks/use-congress";
import { QaList } from "@/features/qa/components/qa-list";
import { useSection } from "@/features/section/api/get-section";
import { pageTitle } from "@/utils/page-title";
import { useTranslation } from "react-i18next";

export function SectionPage() {
  const { t } = useTranslation();
  const { id } = useParams();
  const { congress } = useCongress();

  const {
    data: section,
    isLoading,
    isSuccess: isSectionSuccess,
  } = useSection(id ?? "");

  if (isLoading) {
    return (
      <div>
        <title>{pageTitle(t("meta.section"))}</title>
        <Button variant="link" disabled asChild>
          <Link to="/sections">
            <ArrowLeftIcon className="mr-2 size-4" />
            {t("common.back")}
          </Link>
        </Button>
        <Skeleton className="h-9 w-96" />
      </div>
    );
  }

  if (!isSectionSuccess) {
    return (
      <div>
        <title>{pageTitle(t("meta.section"))}</title>
        <Button variant="link" asChild>
          <Link to="/sections">
            <ArrowLeftIcon className="mr-2 size-4" />
            {t("common.back")}
          </Link>
        </Button>
        <PageHeader title={t("meta.section")} />
        <div>{t("common.error")}</div>
      </div>
    );
  }

  return (
    <div>
      <title>{pageTitle(`${section.shortName} ${section.name}`)}</title>
      <Button variant="link" asChild>
        <Link to="/sections">
          <ArrowLeftIcon className="mr-2 size-4" />
          {t("common.back")}
        </Link>
      </Button>
      <PageHeader title={`${section.shortName} ${section.name}`} />

      <QaList
        congressId={congress.id}
        contentId={section.id}
        eventType="SECTION"
      />
    </div>
  );
}
